import { signal } from 'services/SignalsService'

export default class UserModel {
  constructor() {
    this._data = {
      playerId: '',
      cid: '',
      oid: 0,
    }
  }

  set({ playerId, cid, oid }) {
    playerId = playerId.split('_')[0]
    Object.assign(this._data, { playerId, cid, oid })
    signal.dispatch('USER:SET')
  }

  get() {
    return this._data
  }
}
